/**
 * The "what and who" line for a booking (DNKADM-0448): "Lesson with Ryan Perkins" when the
 * booking has an assigned coach (`assignedStaffName`, the v2 canonical field), otherwise
 * just the service name. `null` when neither is known. The `staff` alias is NOT read: it
 * mirrors the bay on staffless bookings, which would put a bay in the coach slot.
 */
import type { Reservation } from '@/api/reservations';

export function serviceWithCoach(
  reservation: Pick<Reservation, 'serviceName' | 'assignedStaffName'>,
): string | null {
  const coach = reservation.assignedStaffName?.trim() || null;
  const service = reservation.serviceName?.trim() || null;
  if (coach === null) return service;
  return `${service ?? 'Booking'} with ${coach}`;
}
